import VooVIcon from '@asset/image/logo_with_text.png';

import './EnteringHeader.css';

const EnteringHeader = () => (
  <div className="entering-header__wrapper">
    <img src={VooVIcon} alt="" className="entering-header__logo" />
  </div>
);

export default EnteringHeader;
